import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTenant } from '../hooks/useTenant';

const TenantAccessGate = ({ permission, moduleKey, children }) => {
  const { hasPermission, modulesEnabled, permissionsLoading } = useTenant();

  if (permissionsLoading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <span>Loading permissions...</span>
      </div>
    );
  }

  if (permission && !hasPermission(permission)) {
    return (
      <div className="loading">
        <p>Access denied</p>
      </div>
    );
  }

  if (moduleKey && modulesEnabled?.[moduleKey] === false) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default TenantAccessGate;
